export const RECEIVE_TRAINING_STATUS = 'RECEIVE_TRAINING_STATUS';
export const RECEIVE_USER_TRAINING_STATUS = 'RECEIVE_USER_TRAINING_STATUS';
